import { Button, Container } from "react-bootstrap";
import { Link, useRouteError } from "react-router-dom";
import Message from "../Components/Message";
import { PRODUCT_LIST_FALLBACK } from "../utils/navigation";

const RouterErrorScreen = () => {
  const error = useRouteError();
  const status = error?.status;
  const isNotFound = status === 404;

  return (
    <Container className="py-5">
      <Message variant="danger">
        {isNotFound ? "Page not found" : "Something went wrong"}
      </Message>
      <Button as={Link} to={PRODUCT_LIST_FALLBACK} variant="primary">
        Go Home
      </Button>
    </Container>
  );
};

export default RouterErrorScreen;
